import React from 'react';
import { Trophy, Ticket } from 'lucide-react';
import { COUPON_USES } from './data';

const Marquee = () => {
  const row = Array.from({ length: 8 }, (_, i) => <span key={i} className="mx-6">₹2,50,000 PRIZE POOL <span className="text-[#365CFF]">◆</span> BUILD · PITCH · WIN <span className="text-[#365CFF]">◆</span></span>);
  return (
    <div className="bg-[#D7FF38] border-y-2 border-[#111] overflow-hidden py-3" aria-hidden="true">
      <div className="cv-marquee flex w-max whitespace-nowrap cv-display font-extrabold uppercase text-xl">{row}{row}</div>
    </div>
  );
};

export const ConvergePrizes = () => (
  <section id="prizes" className="scroll-mt-20 border-b-2 border-[#111]" data-testid="prizes-section">
    <Marquee />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
      <p className="text-xs font-bold uppercase tracking-[0.25em]">[ 01 ] Prizes</p>
      <h2 className="cv-display font-extrabold uppercase leading-[0.9] mt-3 text-5xl sm:text-7xl lg:text-8xl" data-testid="prizes-title">₹2,50,000<br /><span className="cv-outline">prize pool.</span></h2>
      <p className="mt-6 max-w-xl text-sm sm:text-base font-medium">Bring your best ideas to life, demonstrate your skills, and compete for cash prizes, goodies, and recognition.</p>
      <div className="mt-12 grid lg:grid-cols-5 gap-6">
        <div className="lg:col-span-3 bg-[#111] text-[#F5F3EB] border-2 border-[#111] shadow-[8px_8px_0_#D7FF38] p-7 sm:p-10 cv-lift" data-testid="prize-card-cash">
          <div className="flex items-center justify-between">
            <span className="text-[11px] font-bold uppercase tracking-[0.25em] text-[#D7FF38]">Category A · Hackathon prizes</span>
            <Trophy size={28} className="text-[#D7FF38]" />
          </div>
          <p className="cv-display text-6xl sm:text-8xl font-extrabold mt-8">₹2.5L</p>
          <p className="mt-3 text-lg font-bold uppercase">₹2,50,000 in cash and goodies</p>
          <p className="mt-6 text-xs text-[#F5F3EB]/70 font-medium">Awarded to winning teams based on final jury rankings. Prize distribution will be announced by the organisers.</p>
        </div>
        <div className="lg:col-span-2 bg-white border-2 border-[#111] shadow-[8px_8px_0_#365CFF] p-7 sm:p-8 cv-lift" data-testid="prize-card-coupons">
          <div className="flex items-center justify-between">
            <span className="text-[11px] font-bold uppercase tracking-[0.25em] text-[#365CFF]">Category B · Career coupons</span>
            <Ticket size={26} className="text-[#365CFF]" />
          </div>
          <p className="cv-display text-[2.6rem] sm:text-6xl lg:text-5xl xl:text-6xl font-extrabold mt-8">₹1,00,000</p>
          <p className="mt-2 text-sm font-bold uppercase">Worth of career-development coupons</p>
          <ul className="mt-5 space-y-2">
            {COUPON_USES.map((u) => <li key={u} className="flex gap-2 text-sm font-medium"><span className="text-[#365CFF] font-extrabold">→</span>{u}</li>)}
          </ul>
        </div>
      </div>
      <p className="mt-8 max-w-3xl text-xs font-medium border-l-4 border-[#FF6338] pl-4 py-1" data-testid="prize-disclaimer">
        * The ₹1,00,000 coupon figure represents the stated aggregate coupon value, not cash. Individual coupon values, eligibility, redemption terms, and availability are subject to applicable terms and conditions.
      </p>
    </div>
  </section>
);
